import React, { ReactNode } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { IAppState } from '../../common/models/store/IAppState';
import { useAuth0 } from '@auth0/auth0-react';

type PrivateRouteProps<T> = T & { component: ReactNode }

const Redirect = () => {
  const { loginWithRedirect } = useAuth0();
  loginWithRedirect({ access_type: 'offline' });
  return null;
};

const PrivateRoute = ({ component: Component, isAuthorized, ...rest }: PrivateRouteProps<any>) => (
  <Route
    {...rest}
    render={props => (isAuthorized ? <Component {...props} /> : <Redirect />)}
  />
);

const mapStateToProps = ({ user: { isAuthorized } }: IAppState) => ({ isAuthorized });

export default connect(mapStateToProps)(PrivateRoute);
